import { Box, Button, Paper, Stack, Tab, Tabs, Typography, useTheme } from "@mui/material"

import CustomTabPanel from "../components/CustomTabPanel";

import CostTrialBalanceHistory from "../components/ctb/CostTrialBalanceHistory";
import CTBalanceRecords from "../components/ctb/CtBalanceRecords";
import { isMapped } from "../helpers/constants";
import { CustomTextField } from "../layouts/themes";
import { useState } from "react";




function CostTrialBlance() {
    const theme = useTheme();
   
    const [selectedTabValue, setSelectedTabValue] = useState(1);
    const [year, setYear] =useState<number>(new Date().getFullYear());
    const [yearInput, setYearInput] = useState<number>(new Date().getFullYear());

   



    return (
        <>
            <Box m="1.0rem 1.0rem">
                <Stack>
                    <Paper>
                        <Typography fontWeight="bold" sx={{ margin: '1.0rem', color: theme.palette.secondary.main, fontSize: '13px' }}>
                            Cost Trial Balance Records
                        </Typography>
                    </Paper >
                </Stack>
                <>
                    <Paper>
                        <Box mt="5px" p='0.5rem' gap="14px">
                            <div>
                                <Tabs
                                    variant="fullWidth" value={selectedTabValue} onChange={(event: any, newValue: any) => setSelectedTabValue(Number(newValue))} textColor="secondary"
                                    indicatorColor="secondary" sx={{ fontWeight: 500 }}
                                    aria-label="secondary tabs example">
                                    <Tab label=" CTB Fetch & History" value={1} />
                                    <Tab label="Unmapped Cost Trial Balance Records" value={2} />
                                    <Tab label="Mapped Cost Trial Balance Records" value={3} />

                                </Tabs>
                            </div>

                            <CustomTabPanel value={selectedTabValue} index={1} >
                                <>
                                    <div >
                                        <CostTrialBalanceHistory  />
                                    </div>
                                </>
                            </CustomTabPanel>
                            <CustomTabPanel value={selectedTabValue} index={2} >
                                <div >

                                    <div className='w-1/3 mb-2'>
                                        <CustomTextField size="small" id="outlined-basic" placeholder="Filter By Year..." value={yearInput} onChange={(e) => setYearInput(Number(e.target.value))} variant="outlined" sx={{ width: '70%' }} />&nbsp;&nbsp;
                                        <Button color='info' variant="contained" onClick={() => setYear(yearInput)} style={{ textTransform: 'none', fontSize: 12 }}> Filter By Year</Button>

                                    </div>
                                    
                                    <CTBalanceRecords year={year} setYear={setYear} selectedTabValue={selectedTabValue} setSelectedTabValue={setSelectedTabValue} mappingStatus={isMapped.FALSE} />
                                </div>
                            </CustomTabPanel>
                            <CustomTabPanel value={selectedTabValue} index={3} >
                                <div >
                                    <div className='w-1/3 mb-2 '>
                                        <CustomTextField size="small" id="outlined-basic" placeholder="Filter By Year..." value={yearInput} onChange={(e) => setYearInput(Number(e.target.value))} variant="outlined" sx={{ width: '70%' }} />&nbsp;&nbsp;
                                        <Button color='info' variant="contained" onClick={() => setYear(yearInput)} style={{ textTransform: 'none', fontSize: 12 }}> Filter By Year</Button>

                                    </div>
                                   
                                    <CTBalanceRecords year={year} setYear={setYear}  selectedTabValue={selectedTabValue} setSelectedTabValue={setSelectedTabValue} mappingStatus={isMapped.TRUE} />
                                </div>
                            </CustomTabPanel>

                        </Box>
                    </Paper>
                </>

            </Box>

        </>
    )
}
export default CostTrialBlance;